import LanguageSelect from "./languageSelect.container";

export default LanguageSelect;
